module.exports = __webpack_public_path__ + "img/resource_plus.9bb42662.svg";